import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useResendVerificationCode = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation(() => client.auth.resendVerification(), useMutationOptions);
};
//# sourceMappingURL=useResendVerificationCode.js.map